import { render, staticRenderFns } from "./CalendarDayColor.vue?vue&type=template&id=873aeece"
import script from "./CalendarDayColor.vue?vue&type=script&lang=js"
export * from "./CalendarDayColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports